<template>
  <FouSidebar :isSideBarOpen=isSideBarOpen @toggleSideBar="toggleSideBar">
    <SidebarContent :data="getHealthReportChallenge" />
  </FouSidebar>
  <animation-processing v-if="loading" fill="new-blue" class="dashboard-page-spinner" />
  <div v-else class="fou-dashboard-wrap">
    <div
      :class="['fou-dashboard-top-part', 'dashboard-header-border', { 'fou-dashboard-top-part--hero': showHeroWelcomeSection }, getImpersonateUser ? 'shiftFoundryText' : '']">
      <!-- Foundry Email Verify Banner -->
      <FouEmailVerify labelKey="components.general.verify_email.banner.label" />

      <!-- foundry banner section  -->
      <FoundryBannerSection 
        :bannerURL="bannerURL"
        :logoURL="logoURL"
        :foundryName="currentFoundryName"
        :hasFoundryProfilePermission="hasFoundryProfilePermission"
      />

      <!-- foundry select start -->
      <div class="fou-dashboard-top-part--firstDiv">
        <div class="fou-select-part">
          <foundry-select />
        </div>
      </div>
      <!-- foundry select end -->

    </div>
    
    <div :class="['fou-dashboard-page', dashboardClass]">
      <!-- health meter (top): when visibility score is not 100 -->
      <div v-if="!placeFoundryHealthAfterReport" class="fou-dashboard-page-foundry-health">
        <!-- non ufda2 sign warning message start -->
        <ufda2-agreement v-show="!ufda2Status" :hasAgreementsPermission="hasAgreementsPermission"
          :contractType="contractType" />
        <!-- non ufda2 sign warning message end -->
        <section class="foundryhealth_section">
          <button class="fou-dashboard-sec" @click="toggleFoundryHealthSection">
            <MdIconArrowCaret color="spirits--600" :rotate="showFoundryHealthSection ? 'down' : 'right'" size="md"
              animation="none" duration="1s" as="icon" />
              <MdTypography tag="div" variant="body1--medium">{{ $t('pages.dashboard.components.foundry_health.title') }}</MdTypography>
          </button>

          <VTooltip placement="bottom" :triggers="['click', 'hover']">
            <QuestionMarkInfoIcon v-bind="attrs" v-on="on" />
            <template #popper>
              <div class="header-tooltip-container">
                <h1 class="header-tooltip header-tooltip-heading">{{
                  $t('pages.dashboard.components.foundryHealth.tooltip.heading') }}</h1>
                <p class="header-tooltip header-tooltip-para"> {{
                  $t('pages.dashboard.components.foundryHealth.tooltip.para')
                  }} </p>
              </div>
            </template>
          </VTooltip>
        </section>
        <!-- foundry health start -->
        <div v-if="showFoundryHealthSection" class="foundry-health-component">
          <FoundryHealth @toggleSideBar="toggleSideBar" />
        </div>
        <!-- foundry health end -->
        <div v-if="submissionCounting" class="report-spinner">
          <animation-processing fill="new-blue" />
        </div>
        <!-- report loader end -->
      </div>
      <!-- report section start -->
      <div :class="['fou-dashboard-page-report--margin']">
        <button class="fou-dashboard-sec fou-dashboard-top-sec"
          v-if="!showReportLoader && !submissionCounting && (showHeroWelcomeSection || hasSalesReportPermission)"
          @click="showTopSection">
          <MdIconArrowCaret color="spirits--600" :rotate="showTopSec ? 'down' : 'right'" size="md" animation="none"
            duration="1s" as="icon" />
            <MdTypography tag="div" variant="body1--medium">{{ !showHeroWelcomeSection ?
            $t('pages.dashboard.components.report.title')
            : $t('pages.dashboard.welcome') }}</MdTypography>
        </button>
        <div v-show="showTopSec && hasSalesReportPermission && ufda2Status && (!isSessionFoundryNonActive || sessionFoundryIsAdmin)" class="earning-report-top-div">
          <div v-if="showReportSection" data-qa-id="earning-report" class="earning-report">
            <div data-qa-id="earning-report-chart-type" class="earning-report__chart-type fou-tab">
              <div class="chart-btn">
                <button data-qa-id="chart-type-earnings"
                  :class="['fou-tab__item', { 'fou-tab__item--active': isEarningReport }]"
                  @click="changeEarningType('earnings')">
                  {{ $t('pages.dashboard.earnings') }}
                </button>
                <button data-qa-id="chart-type-earnings"
                  :class="['fou-tab__item', { 'fou-tab__item--active': !isEarningReport }]"
                  @click="changeEarningType('orders')">
                  {{ $t('pages.dashboard.orders') }}
                </button>
              </div>
              <!-- big screen date select start-->
              <div class="fou-daterange-part mobile-only"
                v-if="typeof hasSalesReportPermission == 'object' && Object.keys(hasSalesReportPermission)?.length && !hasNoSubmission">
                <date-select-dropdown data-qa-id="btn-selected-label-mobile"
                  :isBlur="(!isEarningReport && !ufda2Status && !showReportLoader)" :options="DATE_RANGE_OPTIONS" />
              </div>
              <!-- big screen date select end -->
            </div>
            <!-- report loader start -->
            <div v-if="loadingReport" class="report-spinner">
              <animation-processing fill="new-blue" />
            </div>
            <earning-report v-if="!loadingReport" data-qa-id="earning-report-component" />
          </div>
        </div>
        <div v-if="showTopSec && !showReportLoader && hasSalesReportPermission && (!ufda2Status || (isSessionFoundryNonActive && !sessionFoundryIsAdmin))"
          class="earning-report-top-div">
          <blur-report />
        </div>

          <!-- hero welcome start -->
        <section v-if="showHeroWelcomeSection && showTopSec" class="fou-dashboard-page__hero">
          <div class="fou-hero--textpart">
            <h2 class="fou-hero--textpart__title fou-hero--textpart__title--blue">
              {{ $t('pages.dashboard.welcome') }}
            </h2>
            <h2 v-if="currentFoundryName" data-qa-id="welcome-foundry-name"
              class="fou-hero--textpart__title fou-hero--textpart__title--dark">
              {{ currentFoundryName + '!' }}
            </h2>
            <p class="fou-hero--textpart__para">
              {{ $t('pages.dashboard.hero_title') }}
            </p>
          </div>
          <div class="fou-hero--imagepart">
            <div data-qa-id="welcome-foundry-first-letter" class="fou-hero--imagepart__initial">
              {{ currentFoundryInitial }}
            </div>
            <hero-img />
          </div>
        </section>
        <!-- hero welcome end -->
      </div>
      <!-- report section end -->
      <!-- health meter (after report): when visibility score is 100 -->
      <div v-if="placeFoundryHealthAfterReport" class="fou-dashboard-page-foundry-health">
        <!-- non ufda2 sign warning message start -->
        <ufda2-agreement v-show="!ufda2Status" :hasAgreementsPermission="hasAgreementsPermission"
          :contractType="contractType" />
        <!-- non ufda2 sign warning message end -->
        <section class="foundryhealth_section">
          <button class="fou-dashboard-sec" @click="toggleFoundryHealthSection">
            <MdIconArrowCaret color="spirits--600" :rotate="showFoundryHealthSection ? 'down' : 'right'" size="md"
              animation="none" duration="1s" as="icon" />
              <MdTypography tag="div" variant="body1--medium">{{ $t('pages.dashboard.components.foundry_health.title') }}</MdTypography>
          </button>

          <VTooltip placement="bottom" :triggers="['click', 'hover']">
            <QuestionMarkInfoIcon v-bind="attrs" v-on="on" />
            <template #popper>
              <div class="header-tooltip-container">
                <h1 class="header-tooltip header-tooltip-heading">{{
                  $t('pages.dashboard.components.foundryHealth.tooltip.heading') }}</h1>
                <p class="header-tooltip header-tooltip-para"> {{
                  $t('pages.dashboard.components.foundryHealth.tooltip.para')
                  }} </p>
              </div>
            </template>
          </VTooltip>
        </section>
        <!-- foundry health start -->
        <div v-if="showFoundryHealthSection" class="foundry-health-component">
          <FoundryHealth @toggleSideBar="toggleSideBar" />
        </div>
        <!-- foundry health end -->
        <div v-if="submissionCounting" class="report-spinner">
          <animation-processing fill="new-blue" />
        </div>
        <!-- report loader end -->
      </div>
      <!-- health meter end (after report)-->
      <!-- upload first font start -->
      <section v-if="showUploadFirstSection" data-qa-id="individual-first-font" class="individual-first-font">
        <individual-first-font />
      </section>
      <!-- upload first font end -->
      <!-- promotion start -->
      <div class="fou-dashboard-page-promotion" v-if="hasPromotionPermission">
        <button class="fou-dashboard-sec" @click="showPromotionsSection">
          <MdIconArrowCaret color="spirits--600" :rotate="showPromotionsSec ? 'down' : 'right'" size="md"
            animation="none" duration="1s" as="icon" />
            <MdTypography tag="div" variant="body1--medium">{{ $t('pages.dashboard.components.promotion.title') }}</MdTypography>
        </button>
        <section v-if="showPromotionsSec">
          <div v-if="ufda2Status && !isSessionFoundryNonActive">
            <section data-qa-id="promotion" class="mt-4">
              <promotions />
            </section>
          </div>
          <div v-else>
            <blur-promotions />
          </div>
        </section>
      </div>
      <!-- promotion end -->
      <!-- bundle start -->
      <div class="fou-dashboard-page-bundles" v-if="hasBundlesPermission">
        <button class="fou-dashboard-sec" @click="showBundlesSection">
          <MdIconArrowCaret color="spirits--600" :rotate="showBundlesSec ? 'down' : 'right'" size="md" animation="none"
            duration="1s" as="icon" />
            <MdTypography tag="div" variant="body1--medium">{{ $t('pages.dashboard.components.bundle.title') }}</MdTypography>
        </button>
        <section v-if="showBundlesSec">
          <div v-if="ufda2Status && !isSessionFoundryNonActive">
            <section data-qa-id="bundles" class="mt-4">
              <Bundles />
            </section>
          </div>
          <div v-else>
            <BlurBundles />
          </div>
        </section>
      </div>
      <!-- bundle end -->
      <div class="fou-dashboard-page-articles">
        <button class="fou-dashboard-sec" @click="showArticlesSection">
          <MdIconArrowCaret color="spirits--600" :rotate="showArticlesSec ? 'down' : 'right'" size="md" animation="none"
            duration="1s" as="icon" />
            <MdTypography tag="div" variant="body1--medium">{{ $t('pages.dashboard.components.videos_and_articles.title') }}</MdTypography>
        </button>
        <section v-if="showArticlesSec">
          <articles-and-videos v-if="ufda2Status && !isSessionFoundryNonActive" />
          <div v-else>
            <blur-cms />
          </div>
        </section>
      </div>
    </div>
  </div>

  <!-- agreement modal  -->
  <SignAgreementModal v-if="showAgreementModal" :agreementButtonDisabled="hasAgreementsPermission" @handleButtonAction="navigateToAgreementSection" @closeSmallPopupInfoModal="closeSignAgreementModal" ref="signAgreementModal" :heading="$t('components.general.sign_agreement_modal.heading')" :body="$t('components.general.sign_agreement_modal.body')" :btnText="$t('components.general.sign_agreement_modal.sign_agreement')" />  

</template>

<script src="./script.js"></script>

<style src="./stylesheets/index.scss" lang="scss"></style>